import EmberService, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { DataManagerDialogsObject } from '@databox/ember-integrations/lib/components/DataManagerDialogs/DataManagerDialogs';

import type { Service } from 'webapp-types';

export default class DataManagerService extends EmberService {
	@service('account') declare accountService: Service.Account;
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;

	@tracked dataManagerFunctions?: DataManagerDialogsObject = undefined;

	get functions(): DataManagerDialogsObject | undefined {
		return this.dataManagerFunctions;
	}

	changeSourceTimezone(
		dataSource: Parameters<
			DataManagerDialogsObject['openDataSourceTimezoneDialog']
		>[0]['dataSource'],
	): void {
		this.functions?.openDataSourceTimezoneDialog({ dataSource }).then(
			({ timezone, applyToDescendants }) => {
				this.mmSourcesService.sourceModels
					.filter(
						(source) =>
							source.numericId === dataSource.id ||
							(applyToDescendants &&
								source.parentInfo?.spaceAccessId === dataSource.id),
					)
					.forEach((source) => source.directPropUpdate({ timezone }));

				this.infolayerService.ok('Data source timezone changed successfully!');
			},
			() => undefined,
		);
	}
}

declare module '@ember/service' {
	interface Registry {
		'data-manager': DataManagerService;
	}
}
